import { DashboardPage } from './Dashboard/DashboardPage';

const PrivateHome = () => {
  return <DashboardPage />;
};

export default PrivateHome;
